import ConfirmationPopup from "src/components/shared/ConfirmationPopup";
import { media } from "src/styles/mixins";
import styled from "styled-components";

export const GameSummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const GameSummaryHeading = styled.h2`
  text-align: center;
`;

export const ButtonsContainer = styled.div<{ centeredButtons?: boolean }>`
  display: flex;
  justify-content: ${({ centeredButtons }) =>
    centeredButtons ? "center" : "space-between"};
  margin-top: auto;

  button {
    width: 208px;
  }

  button:first-child {
    margin-right: 24px;
  }
`;

export const EndGameConfirmationPopup = styled(ConfirmationPopup)`
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 2 * 15px);

  ${media.up("TABLET")`
    width: 448px;
  `}
`;
